import React, { Children, forwardRef, useContext } from "react";
import PropTypes from "prop-types";

import { ButtonGroupContext } from "./ButtonGroupContext";
import { Button } from "../Button";

import styles from "./ButtonGroup.scss";

const ButtonGroupItem = forwardRef((props, ref) => {
  const { children, checked, ...restProps } = props;
  const { id, name } = restProps;
  const group = useContext(ButtonGroupContext) || {};
  const inputId = id || group.childId;
  const inputName = name || group.name;

  const textChildren = Children.toArray(children).filter(
    (child) => typeof child === "string"
  );

  return (
    <li className={styles.item} ref={ref}>
      <input
        id={inputId}
        name={inputName}
        type="radio"
        className={styles.input}
        {...restProps}
        onChange={(event) => {
          group.onCheck(children, event);
        }}
        value={textChildren}
        checked={group.value === children || (group.value === "" && checked)}
      />
      <Button
        variants={[
          Button.Variant.reactangle,
          children.length ? "" : Button.Variant.icon,
          group.value === children || (group.value === "" && checked)
            ? Button.Variant.inverted
            : Button.Variant.clean,
        ]}
        tag="label"
        htmlFor={inputId}
      >
        {children}
      </Button>
    </li>
  );
});

ButtonGroupItem.propTypes = {
  checked: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

ButtonGroupItem.defaultProps = {
  checked: false,
};

ButtonGroupItem.displayName = "ButtonGroup.Item";

export default ButtonGroupItem;
